"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const formatBoolean = (val) => {
    if (val === true) {
        return 'Yes';
    }
    else {
        return 'No';
    }
};
exports.formatBoolean = formatBoolean;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYm9vbGVhbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9mb3JtYXR0ZXJzL2Jvb2xlYW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxNQUFNLGFBQWEsR0FBRyxDQUFDLEdBQStCLEVBQVUsRUFBRTtJQUNoRSxJQUFJLEdBQUcsS0FBSyxJQUFJLEVBQUU7UUFDaEIsT0FBTyxLQUFLLENBQUM7S0FDZDtTQUFNO1FBQ0wsT0FBTyxJQUFJLENBQUM7S0FDYjtBQUNILENBQUMsQ0FBQztBQUVPLHNDQUFhIn0=